module.exports = __webpack_public_path__ + "static/img/ios.67c986a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/cn/ios.png
// module id = xp05
// module chunks = 1